<template>
  <div class="flex flex-col items-center m-5 mt-24 text-white">
    <div v-for="(mensaje, index) in mensajes" :key="index" class="mt-5 font-bold">
      <Mensaje :mensaje="mensaje" icono="exclamation-triangle" />
    </div>
    <div>
      <button @click="inicio" class="bg-paleta-3 hover:bg-blue-700 text-white font-bold mt-5 py-2 px-4 rounded">Entrar</button>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Mensaje from "@/components/Mensaje.vue";

export default {
  components: { Mensaje },
  data() {
    return {
      mensajes: []
    };
  },
  mounted() {
    if (this.usuario.geoControl.mensaje != "") {
      this.mensajes.push(this.usuario.geoControl.mensaje);
    }
    if (this.usuario.datosPersonales.mensaje != "") {
      this.mensajes.push(this.usuario.datosPersonales.mensaje);
    }
  },
  methods: {
    inicio() {
      this.$router.push("/menu");
    }
  },
  computed: {
    ...mapState({
      usuario: state => state.sesion.usuario
    })
  }
};
</script>
